const addCategory = (() => {
    //Inputs
    let BtnName;
    let SAVE_BTN = document.querySelector('.addOutcomeBtnWrap button');
    let categoryId, category, type, repPayee, code;
    let categoryInput;  
    let accountname, registerID, pageName;

    async function init(categoryID, Category, Type, RepPayee, Code, accountName, registerId, page) {
        categoryId = categoryID;
        category = Category;
        type = Type;
        repPayee = RepPayee;
        code = Code;
        accountname = accountName;
        registerID = registerId;
        pageName = page;

        buildNewCategory();
        if (SAVE_BTN) {
            SAVE_BTN.classList.add('disabled');
        }
    }

    async function buildNewCategory() {
        DOM.clearActionCenter();
        DOM.scrollToTopOfPage();
        landingPage = document.createElement('div');
        const importantOutcomeForm = await buildOutComeForm();
        landingPage.appendChild(importantOutcomeForm);
        DOM.ACTIONCENTER.appendChild(landingPage);
    }

    async function buildOutComeForm() {
        const categoryInfoDiv = document.createElement('div');
        categoryInfoDiv.classList.add('additionalQuestionWrap');

        if (categoryId != '0') {
            BtnName = 'UPDATE';
        }
        else {
            category = '';
            type = '';
            repPayee = '';
            code = '';
            BtnName = 'SAVE';
        }

        categoryInput = input.build({
            id: 'categoryInput',
            type: 'text',
            label: 'Category',
            style: 'secondary',
            value: category,
        });
        codeInput = input.build({
            id: 'codeInput',
            type: 'text',
            label: 'Code',
            style: 'secondary',
            value: code,
        });

        categoryTypeDropdown = dropdown.build({
            dropdownId: 'categoryTypeDropdown',
            label: 'Type',
            style: 'secondary',
            value: type,
        });

        categoryRapDropdown = dropdown.build({
            dropdownId: 'categoryRapDropdown',
            label: 'Rep Payee',
            style: 'secondary',
            value: repPayee,
        });


        // button
        SAVE_BTN = button.build({
            text: BtnName,
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                if (!SAVE_BTN.classList.contains('disabled')) {
                    SAVE_BTN.classList.add('disabled');
                    await saveUpdateCategory();
                }
            },
        });
        CANCEL_BTN = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: async () => { cfEditCategories.init(accountname, registerID, pageName) },
        });

        const column1 = document.createElement('div')
        column1.classList.add('col-1')
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCard.innerHTML = `<div class="card__header">Category</div>`;
        addNewCard.appendChild(addNewCardBody)
        column1.appendChild(addNewCard)

        categoryInput.style.marginBottom = '5px';
        addNewCardBody.appendChild(categoryInput);

        var confirmMessage = document.createElement('div');
        confirmMessage.innerHTML = `<h3 id="confirmMessage" class="confirmMessage password-warning"></h3>`;
        confirmMessage.style.marginBottom = '15px'; 
        confirmMessage.style.fontSize = '14px'; 
        addNewCardBody.appendChild(confirmMessage);

        var dateWrap = document.createElement('div');
        dateWrap.classList.add('addOutcomedateWrap');
        codeInput.style.width = '32%'
        dateWrap.appendChild(codeInput);
        categoryTypeDropdown.style.width = '32%'
        categoryTypeDropdown.style.marginLeft = '2%';
        dateWrap.appendChild(categoryTypeDropdown);
        categoryRapDropdown.style.width = '32%';
        categoryRapDropdown.style.marginLeft = '2%';
        dateWrap.appendChild(categoryRapDropdown);
        addNewCardBody.appendChild(dateWrap);

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('addOutcomeBtnWrap');
        btnWrap.style.marginLeft = '25%';
        btnWrap.style.width = '50%';

        SAVE_BTN.style.width = '52%';
        btnWrap.appendChild(SAVE_BTN);

        CANCEL_BTN.style.width = '52%';
        CANCEL_BTN.style.marginLeft = '5%';
        btnWrap.appendChild(CANCEL_BTN);
        addNewCardBody.appendChild(btnWrap);

        categoryInfoDiv.appendChild(column1);
        populateCategoryDropdown();
        eventListeners();
        requiredFieldsOfAddCategory(category, code, type);
        return categoryInfoDiv;
    }


    async function populateCategoryDropdown() {
        const { getcategoryRapDropDownOfFilterResult: categoryRap } = await ConsumerFinancesAjax.getcategoryRapDropDownOfFilter();
        let categoryRapData = categoryRap.map(categoryrep => ({
            id: categoryrep.CategoryID,
            value: categoryrep.CategoryID,
            text: categoryrep.CategoryDescription,
        }));
        categoryRapData.unshift({ id: '', value: '', text: '' });
        dropdown.populate('categoryRapDropdown', categoryRapData, repPayee);

        const categoryTypeData = ([
            { id: 1, value: 'E', text: 'Expense' },
            { id: 2, value: 'I', text: 'Income' },
        ]);
        categoryTypeData.unshift({ id: '', value: '', text: '' });
        dropdown.populate('categoryTypeDropdown', categoryTypeData, type);

    }

    function eventListeners() {
        categoryTypeDropdown.addEventListener("change", event => {
            var selectedOption = event.target.options[event.target.selectedIndex];
            type = selectedOption.value;
            checkrequiredFieldsOfAddCategory();
        });

        categoryRapDropdown.addEventListener("change", event => {
            var selectedOption = event.target.options[event.target.selectedIndex];
            repPayee = selectedOption.value;
            checkrequiredFieldsOfAddCategory();
        });

        codeInput.addEventListener('input', event => {
            code = event.target.value.trim();
            checkrequiredFieldsOfAddCategory();
        });
        categoryInput.addEventListener('input', event => {
            category = event.target.value;
            checkrequiredFieldsOfAddCategory();
        });
    }

    function checkrequiredFieldsOfAddCategory() {
        var categoryVal = categoryInput.querySelector('#categoryInput');
        var codeVal = codeInput.querySelector('#codeInput');
        var typeVal = categoryTypeDropdown.querySelector('#categoryTypeDropdown');

        requiredFieldsOfAddCategory(categoryVal.value, codeVal.value, typeVal.value)
    }

    function requiredFieldsOfAddCategory(categoryVal, codeVal, typeVal) {
        if (categoryVal.trim() === '') {
            categoryInput.classList.add('error');
        } else {
            categoryInput.classList.remove('error');
        }

        if (typeVal != 'E' && typeVal != 'I') {
            categoryTypeDropdown.classList.add('error');
        } else {
            categoryTypeDropdown.classList.remove('error');
        }

        setBtnStatusOfAddCategory();
    }

    function setBtnStatusOfAddCategory() {
        var hasErrors = [].slice.call(document.querySelectorAll('.error'));
        if (hasErrors.length > 0) {
            SAVE_BTN.classList.add('disabled');
            return;
        } else {
            SAVE_BTN.classList.remove('disabled');
        }
    }

    async function saveUpdateCategory() {
        const result = await ConsumerFinancesAjax.insertUpdateCategory(categoryId, category.trim(), type, code.trim(), repPayee); 
        const { insertUpdateCategoryResult } = result;

        var messagetext = document.getElementById('confirmMessage');
        messagetext.innerHTML = ``;

        if (insertUpdateCategoryResult.CategoryID == '-1') { 
            messagetext.innerHTML = 'This category already exists.';
            categoryInput.classList.add('error');
            messagetext.classList.add('password-error');            
        } else {
            cfEditCategories.init(accountname, registerID, pageName);  
        }
    }

    return {
        init,
        buildNewCategory,
    };
})(); 
